// extracted by mini-css-extract-plugin
export var cartContainer = "_ob-4";
export var gray = "_ob-1";
export var itemContainer = "_ob-2";
export var itemDetails = "_ob-3";
export var strong = "_ob-0";